import React from 'react';
import { componentService } from 'js/services/component.service';

export const DateTimeDisplay = React.lazy(() => import(/* webpackChunkName: "date-time-display" */ './DateTimeDisplay'));

// <hub2-date-time-display tz="America/Detroit" format="yyyy-MM-dd HH:mm:ss"></hub2-date-time-display>
componentService.registerWebContentComponents({ DateTimeDisplay });
